<template>
  <div class="rj-page-card">
    <div class="rj-page-card__title">
      附件信息
    </div>
    <div class="rj-page-card__content">
      <el-table :data="tableData" border style="width: 100%">
        <!-- <el-table-column type="selection" width="55" align="left" /> -->
        <el-table-column prop="rFileName" label="文件名称" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="openContract(row.rFileCode)">
              {{ row.rFileName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="rCreatedBy" label="上传人" align="left" />
        <el-table-column prop="rCreatedTime" label="上传时间" align="left" />
        <el-table-column prop="pName" label="操作" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="downOneFile(row.rFileCode)">
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
    </div>
  </div>
</template>
<script>
import { attachmentGetToken, getUrlByFileID } from '@/API';

export default {
  data () {
    return {
      multipleSelection: [],
      fileList: [],
      tableLoading: false,
      uploadUrl: '',
      downFileUrl: '',
      token: '',
      fileserveDownUrl: '',
      tableData: this.contractAttachmentListData
    };
  },
  components: {
  },
  props: {
    contractAttachmentListData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    contractAttachmentListData (val) {
      this.tableData = val;
    }
  },
  computed: {},
  mounted () {
    // this.searchFiles();
    this.initToken();
  },
  methods: {
    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    openContract (fileToken) {
      getUrlByFileID(fileToken).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          window.open(json.data);
        }
      }).catch((res) => {

      });
    },
    downzipFile (token, url) {
      this.fileserveDownUrl = url + `?Token=${token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    downOneFile (id) {
      this.fileserveDownUrl = this.downFileUrl + `/${id}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    }
  }
};
</script>
